export const secondJobQuestions: Record<string, any> = {
  hasSecondJob: {
    labelKey: 'applicationForm.SECOND_JOB.hasSecondJob.label',
    options: [
      { labelKey: 'common.yes', value: 'true' },
      { labelKey: 'common.no', value: 'false' },
    ],
  },
};
